export default function changeLangURL(targetLang: string) {
    const currentURL = window.location.href;
    let newURL = ""
    if (currentURL.match(/lang-[a-z]{2}/)) {
        newURL = currentURL.replace(/lang-[a-z]{2}/, 'lang-' + targetLang)
    } else {
        // Znajdź pozycję pierwszego slasha po "http(s)://"
        const firstSlashIndex = currentURL.indexOf('/', currentURL.indexOf('//') + 2);
        if (firstSlashIndex !== -1) {
            // Wstaw język po pierwszym slashu
            newURL = currentURL.slice(0, firstSlashIndex + 1) + 'lang-' + targetLang + '/' + currentURL.slice(firstSlashIndex + 1);
        } else {
            // Jeśli nie ma dalszych slashów, dodaj język na końcu
            newURL = currentURL + '/lang-' + targetLang + '/';
        }
    }
    window.location.href = newURL
}